import React from 'react'
import styled from 'styled-components'
import optoppingenDesktop from '../../img/vs/optoppingen-desktop.svg'
import optoppingenMobile from '../../img/vs/optoppingen-mobile.svg'
import appartementenDesktop from '../../img/vs/appartementen-desktop.svg'
import appartementenMobile from '../../img/vs/appartementen-mobile.svg'
import doosindoosDesktop from '../../img/vs/doosindoos-desktop.svg'
import doosindoosMobile from '../../img/vs/doosindoos-mobile.svg'
import herbestemmingDesktop from '../../img/vs/herbestemming-desktop.svg'
import herbestemmingMobile from '../../img/vs/herbestemming-mobile.svg'
import prefabelementenDesktop from '../../img/vs/prefabelementen-desktop.svg'
import prefabelementenMobile from '../../img/vs/prefabelementen-mobile.svg'
import woningbouwDesktop from '../../img/vs/woningbouw-desktop.svg'
import woningbouwMobile from '../../img/vs/woningbouw-mobile.svg'
import extraverdiepingDesktop from '../../img/vs/extraverdieping-desktop.svg'
import extraverdiepingMobile from '../../img/vs/extraverdieping-mobile.svg'
import aanbouwDesktop from '../../img/vs/aanbouw-desktop.svg'
import aanbouwMobile from '../../img/vs/aanbouw-mobile.svg'

import ParseContent from '../shared/ParseContent'
import BoxDefault from './BoxDefault'

const Section = styled.section`
  @media (min-width: 992px) {
    padding-top: 5rem;
    padding-bottom: 12rem;
  }
`

const Container = styled.div`
  position: relative;

  & .bg-extender {
    position: absolute;
    background-color: #e5e5e5;
    height: 100%;
    width: 2000px;
    top: 0;
    right: 98%;
  }

  @media (max-width: 991.98px) {
    & .bg-extender {
      display: none;
    }
  }
`

const VsContent = styled(BoxDefault)`
  width: fit-content;
  height: fit-content;

  background-color: #000;
  padding: 4rem;

  &:after {
    border-top-width: 50px;
    border-right-width: 50px;
    border-right-color: #fff;
  }

  & strong:first-child {
    color: #d50021;
  }

  * {
    color: #fff;
  }

  @media (min-width: 992px) {
    position: absolute;
    left: 10%;
    top: -20%;

    &:after {
      border-right-color: #e5e5e5;
    }

    & h2 {
      font-size: 40px;
    }
  }
`

function Vs({ location, description }) {
  let desktopImage
  let mobileImage

  switch (location) {
    case '/optopping/':
      desktopImage = optoppingenDesktop
      mobileImage = optoppingenMobile
      break
    case '/appartementen/':
      desktopImage = appartementenDesktop
      mobileImage = appartementenMobile
      break
    case '/doos-in-doos/':
      desktopImage = doosindoosDesktop
      mobileImage = doosindoosMobile
      break
    case '/herbestemming/':
      desktopImage = herbestemmingDesktop
      mobileImage = herbestemmingMobile
      break
    case '/prefab-elementen/':
      desktopImage = prefabelementenDesktop
      mobileImage = prefabelementenMobile
      break
    case '/woningbouw/':
      desktopImage = woningbouwDesktop
      mobileImage = woningbouwMobile
      break
    case '/extra-verdieping/':
      desktopImage = extraverdiepingDesktop
      mobileImage = extraverdiepingMobile
      break
    case '/aanbouw/':
      desktopImage = aanbouwDesktop
      mobileImage = aanbouwMobile
      break
    default:
      break
  }

  return (
    <Section>
      <Container className="container">
        <div className="bg-extender" />
        <VsContent>
          <ParseContent content={description} />
        </VsContent>
        <div className="d-lg-block d-none">
          <img src={desktopImage} alt="" className="w-100" />
        </div>
        <div className="d-lg-none">
          <img src={mobileImage} alt="" className="w-100" />
        </div>
      </Container>
    </Section>
  )
}

export default Vs
